import { tWithKeyAttr as t } from "../../i18nHelper";
import { AppImage } from "../appMedia";
import { IMessage } from "../../utils/types";
import messageStyles from "./message.module.css";
import avatarPlaceholder from "../../images/avatar_placeholder_purple.svg";
import { getTimeFromTimestamp, venchyData } from "../../utils/utils";

function Message({
  message,
  isOwnMessage,
  isLoading,
  onEditClick,
}: {
  message: IMessage;
  isOwnMessage: boolean;
  isLoading?: boolean;
  onEditClick: (questionId: number) => void;
}) {
  const messageClassname = isOwnMessage
    ? messageStyles.ownMessage
    : messageStyles.message;
  const containerClassname = isOwnMessage
    ? messageStyles.ownMessageContainer
    : messageStyles.messageContainer;

  const avatar = isOwnMessage ? avatarPlaceholder : venchyData.avatar;
  const alt = isOwnMessage ? t('MARKING_LOCATION_OF_FIGURE') : venchyData.name;

  const shouldShowEditButton =
  isOwnMessage &&
  !isLoading &&
  message.questionId &&
  message.questionId > 0;

  return (
    <>
      <div className={containerClassname}>
        <AppImage src={avatar} alt={alt} className={messageStyles.avatar} />
        <div className={`${messageClassname}`}>
          <p className={messageStyles.text}>
            {message.message?.split("\n").map((part, index) => (
              <span
              key={`${message.messageId}-${index}`}
              className={messageStyles.textPart}
              data-testid={`message`}
              >
                {part}
              </span>
            ))}
          </p>
          <div className={messageStyles.textContainer}>
            <p
              className={`${messageStyles.time} ${
                isOwnMessage && messageStyles.time_ownMessage
              }`}
            >
              {getTimeFromTimestamp(message.date)}
            </p>
            {shouldShowEditButton && (
              <button
                type={"button"}
                disabled={isLoading}
                data-testid="edit-chat-message"
                className={`${messageStyles.btn} ${messageStyles.btn_type_edit}`}
                onClick={() => {
                  if (message.questionId) {
                    onEditClick(message.questionId);
                  }
                }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Message;
